import { createFileRoute } from '@tanstack/react-router'
import AdminUserDetailPage from '@/components/pages/Admin/AdminUserDetailPage/AdminUserDetailPage'

export const Route = createFileRoute('/$workspaceName/$environment/admin/users/$userId')({
  component: AdminUserDetailRoute,
})

function AdminUserDetailRoute() {
  return <AdminUserDetailPage />
}
